// extracted by mini-css-extract-plugin
export var details = "_e6-0";
export var inspectorPopover = "_e6-1";